import {useQuery} from '@tanstack/react-query';

import {useApplePayStripe} from 'hooks/useApplePayStripe/useApplePayStripe';

const APPLE_PAY_AVAILABILITY_KEY = 'APPLE_PAY_AVAILABILITY_KEY';

/**
 * Check is stripe apple pay available
 */
export const useApplePayAvailability = () => {
    const stripe = useApplePayStripe();

    const {data} = useQuery({
        enabled: Boolean(stripe),
        queryFn: async () => {
            // This request only need to check if apple pay available
            const request = stripe?.paymentRequest({
                country: 'US',
                currency: 'usd',
                total: {
                    amount: 0,
                    label: 'Total',
                },
            });

            if (!request) return null;

            const result = await request.canMakePayment();

            return result?.applePay || null;
        },
        queryKey: [APPLE_PAY_AVAILABILITY_KEY],
        refetchInterval: false,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
    });

    return data ?? null;
};
